import { standardApiHandler } from "../../../core/core-api/apiTools";
import { validateSessionAdapter } from "./validateSession.adapter";

export type ValidateSessionServiceParams = {};
export type ValidateSessionServiceResponse = boolean;

export type ValidateSessionService = (params: ValidateSessionServiceParams) => Promise<ValidateSessionServiceResponse>;
export const validateSessionService: ValidateSessionService = standardApiHandler(validateSessionAdapter);
